import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "strategy-brief-redirection-regular" }
const _hoisted_2 = {
  key: 0,
  class: "strategy-brief-redirection-regular__loader"
}
const _hoisted_3 = { class: "b-loader__label" }

import RedirectionStrategyToRegular from '@/brief-hub/splash-screen/RedirectionStrategyToRegular.vue';
    import {useBriefStrategyStore} from '@/brief-hub/stores/briefStrategy.store';
    import {storeToRefs} from 'pinia';
    import {ref} from 'vue';

    const LOADING_TIMEOUT = 3000;

    
export default /*@__PURE__*/_defineComponent({
  __name: 'StrategyBriefRedirectionRegular',
  setup(__props) {

    const loading = ref<boolean>(true);
    const briefStrategyStore = useBriefStrategyStore();
    const {originReferrer} = storeToRefs(briefStrategyStore);

    function closeRedirection() {
        if (originReferrer.value && typeof originReferrer.value === 'string') {
            window.location.href = originReferrer.value;
        } else {
            // Have to refresh page to prevent funnel mode, so use window.location instead of $router.push().
            window.location.href = '/project-proposal-summaries';
        }
    }

    function init() {
        setTimeout(() => (loading.value = false), LOADING_TIMEOUT);
    }

    init();

return (_ctx: any,_cache: any) => {
  const _component_VJoyTemplate = _resolveComponent("VJoyTemplate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VJoyTemplate, null, {
      "template-main": _withCtx(() => [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "m-loader" }, null, -1)),
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$msg('customer.brief.strategy.redirection.loader.text')), 1)
            ]))
          : (_openBlock(), _createBlock(RedirectionStrategyToRegular, {
              key: 1,
              onClose: closeRedirection
            }))
      ]),
      _: 1
    })
  ]))
}
}

})